<template>
  <div>
    <div class="record-info" v-loading="loading">
      <div class="record-info-title">药品信息</div>
      <div class="record-info-item-box">
        <div class="record-info-item">
          <div class="record-info-item-label">药品通用名</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.commonName"
            class="record-info-item-value"
          >
            {{ drugInfo.commonName }}
          </EllipsisTooltip>
        </div>
        <div class="record-info-item">
          <div class="record-info-item-label">剂型</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.dosageForm"
            class="record-info-item-value"
          >
            {{ drugInfo.dosageForm }}
          </EllipsisTooltip>
        </div>
        <div class="record-info-item">
          <div class="record-info-item-label">制剂规格</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.drugSpecification"
            class="record-info-item-value"
          >
            {{ drugInfo.drugSpecification }}
          </EllipsisTooltip>
        </div>
        <div class="record-info-item">
          <div class="record-info-item-label">货主机构</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.ownEnterprise"
            class="record-info-item-value"
          >
            {{ drugInfo.ownEnterprise }}
          </EllipsisTooltip>
        </div>
        <div class="record-info-item">
          <div class="record-info-item-label">上市持有人</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.quotedHolder"
            class="record-info-item-value"
          >
            {{ drugInfo.quotedHolder }}
          </EllipsisTooltip>
        </div>
        <div class="record-info-item">
          <div class="record-info-item-label">批准文号</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.approvalNo"
            class="record-info-item-value"
          >
            {{ drugInfo.approvalNo }}
          </EllipsisTooltip>
        </div>
        <div class="record-info-item">
          <div class="record-info-item-label">文号有效期</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.approvalNoEndDate"
            class="record-info-item-value"
          >
            {{ drugInfo.approvalNoEndDate }}
          </EllipsisTooltip>
        </div>
        <div class="record-info-item">
          <div class="record-info-item-label">药品本位码</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.standardCode"
            class="record-info-item-value"
          >
            {{ drugInfo.standardCode }}
          </EllipsisTooltip>
        </div>
        <div v-if="type === 0" class="record-info-item">
          <div class="record-info-item-label">生产批次</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.batchNo"
            class="record-info-item-value"
          >
            {{ drugInfo.batchNo }}
          </EllipsisTooltip>
        </div>
        <div v-if="type === 0" class="record-info-item">
          <div class="record-info-item-label">包装规格</div>
          ：
          <EllipsisTooltip
            :content="drugInfo.packageSpecification"
            class="record-info-item-value"
          >
            {{ drugInfo.packageSpecification }}
          </EllipsisTooltip>
        </div>
        <div class="record-info-item">
          <div class="record-info-item-label">库存</div>
          ：
          <div class="record-info-item-value">
            {{ drugInfo.quantity }}
          </div>
        </div>
      </div>
      <div class="record-info-button-box">
        <span
          class="record-info-button blue"
          style="margin-right: 11px"
          @click="handleQuantityClick"
          >全部追溯码</span
        >
      </div>
    </div>

    <div class="record-search">
      <div class="record-search-item">
        <div class="search-item">
          <div class="search-item-label">单据日期</div>
          <div class="search-item-value">
            <el-date-picker
              v-model="queryParam.orderDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%"
              size="mini"
              value-format="yyyy-MM-dd"
              :editable="false"
            />
          </div>
        </div>
        <div class="search-item">
          <div class="search-item-label">单据编号</div>
          <div class="search-item-value">
            <el-input
              v-model="queryParam.orderNo"
              placeholder="请输入内容"
              style="font-size: 13px"
              size="mini"
              @keyup.enter.native="handleSearch"
            />
          </div>
        </div>
        <div class="search-item">
          <div class="search-item-label">单据类型</div>
          <div class="search-item-value">
            <el-select
              v-model="queryParam.orderType"
              placeholder="请选择"
              size="mini"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.orderTypes"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="search-item">
          <div class="search-item-label">往来机构</div>
          <div class="search-item-value">
            <el-input
              v-model="queryParam.relationEnterpriseName"
              placeholder="请输入内容"
              size="mini"
              style="font-size: 13px"
              @keyup.enter.native="handleSearch"
            />
          </div>
        </div>
      </div>
      <div class="record-search-item">
        <div class="search-item">
          <div class="search-item-label">机构类型</div>
          <div class="search-item-value">
            <el-select
              v-model="queryParam.enterpriseTypes"
              multiple
              collapse-tags
              size="mini"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.enterpriseTypes"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div v-if="type !== 0" class="search-item">
          <div class="search-item-label">生产批次</div>
          <div class="search-item-value">
            <el-input
              v-model="queryParam.batchNo"
              placeholder="请输入内容"
              size="mini"
              style="font-size: 13px"
              @keyup.enter.native="handleSearch"
            />
          </div>
        </div>
        <div v-if="type !== 0" class="search-item">
          <div class="search-item-label">包装规格</div>
          <div class="search-item-value">
            <el-select
              v-model="queryParam.packageSpecification"
              multiple
              collapse-tags
              size="mini"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.packageSpecifications"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>
      <div class="record-search-button">
        <el-button type="primary" size="mini" @click="handleSearch"
          >查询</el-button
        >
        <el-button plain size="mini" @click="handleReset">重置</el-button>
      </div>
    </div>

    <div class="record-table">
      <div class="table-box">
        <div class="table-button">
          <el-button
            type="primary"
            size="mini"
            @click="handleExport"
            :loading="buttonLoading"
          >
            <i class="el-icon-download"></i>
            导出
          </el-button>
        </div>
        <div class="table-d">
          <el-table
            ref="workTableRef"
            :data="tableList"
            stripe
            :header-cell-style="{
              background: '#F0F3F7',
              color: '#2a354e',
              fontWeight: 400,
            }"
            height="300"
            highlight-current-row
            :row-key="'id'"
            @row-click="handleRowClick"
            @sort-change="handleSortChange"
            v-loading="loading"
            size="mini"
          >
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <span
                  style="color: #4076f2; cursor: pointer"
                  @click="handleTableDetail(scope.row)"
                  >单据详情</span
                >
                <span
                  style="color: #6bc440; cursor: pointer; margin-left: 10px"
                  @click="handleTableCode(scope.row)"
                  >追溯码详情</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="orderNo"
              label="单据编号"
              width="250"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              prop="orderDate"
              label="单据时间"
              width="200"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              prop="orderClass"
              label="单据类型"
              width="150"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              prop="quantity"
              label="交易量"
              width="150"
              :show-overflow-tooltip="true"
              sortable="custom"
            />
            <el-table-column
              prop="relationEnterpriseName"
              label="往来机构"
              width="250"
            />
            <el-table-column
              prop="relationEnterpriseType"
              label="机构类型"
              width="150"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              prop="relationEnterpriseLocation"
              label="地理位置"
              min-width="250"
              :show-overflow-tooltip="true"
            />
          </el-table>
        </div>
        <div class="table-page">
          <div class="table-page-index">当前 {{ paging.index }} 页</div>
          <el-pagination
            :current-page="paging.index"
            :page-size="paging.size"
            layout="total,  prev, pager, next, jumper"
            :total="total"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <Code ref="codeRef" />
    <OrderDetail ref="orderDetailRef" />
  </div>
</template>

<script>
import Code from "@/components/CodeList";
import OrderDetail from "@/components/OrderDetail";
import EllipsisTooltip from "@/components/EllipsisTooltip";

export default {
  name: "Record",
  components: { Code, OrderDetail, EllipsisTooltip },
  props: {},
  data() {
    return {
      filterData: {},
      type: 0,
      drugInfo: {},
      queryParam: {
        standardCode: "",
        enterpriseName: "",
        nationalDrugCode: "",
        batchNo: "",
        packageSpecification: [],
        orderDirection: 0,
        orderDate: [],
        orderNo: "",
        orderType: "",
        relationEnterpriseName: "",
        enterpriseTypes: [],
        orders: {
          quantity: false,
        },
      },
      paging: {
        index: 1,
        size: 100,
      },
      total: 0,
      tableList: [],
      selectedRow: null,
      loading: false,
      buttonLoading: false,
    };
  },
  methods: {
    handleSortChange(value) {
      // 交易量
      if (value.prop === "quantity") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.quantity = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.quantity = true;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.quantity = false;
        }
      }
      this.paging.index = 1;
      this.getList();
    },
    handleRowClick(row) {
      this.selectedRow = row;
    },
    async handleExport() {
      this.$confirm("是否确认导出当前列表?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.buttonLoading = true;
        let res = await this.$api.exportCenter.ExportStockBatchOrderList({
          ...this.queryParam,
        });
        this.buttonLoading = false;
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = `往来记录_${new Date().toISOString().slice(0, 10)}.xls`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.$notify({
          title: "导出成功!",
          type: "success",
          message: "选中内容导出成功。",
          dangerouslyUseHTMLString: true,
          position: "bottom-right",
          duration: 4000,
          customClass: "notify-success-title",
        });
      });
    },
    handleTableCode(value) {
      this.$refs.codeRef.show({
        standardCode: this.queryParam.standardCode,
        enterpriseName: this.queryParam.enterpriseName,
        batchNo: this.queryParam.batchNo,
        orderId: value.id,
        partitionIndex: value.partitionIndex,
        orderTable: value.orderTable,
      });
    },
    handleSearch() {
      this.paging.index = 1;
      this.getList();
    },
    handleReset() {
      if (this.type !== 0) {
        this.queryParam.batchNo = "";
      }
      if (this.type !== 0) {
        this.queryParam.packageSpecification = [];
      }
      this.queryParam.orderDirection = this.type;
      this.queryParam.orderDate = [];
      this.queryParam.orderNo = "";
      this.queryParam.orderType = "";
      this.queryParam.relationEnterpriseName = "";
      this.queryParam.enterpriseTypes = [];
    },
    handleQuantityClick() {
      this.$refs.codeRef.show({
        standardCode: this.queryParam.standardCode,
        enterpriseName: this.queryParam.enterpriseName,
        batchNo: this.queryParam.batchNo,
      });
    },
    handleSizeChange(value) {
      this.paging.index = 1;
      this.paging.size = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.paging.index = value;
      this.getList();
    },
    handleTableDetail(value) {
      value.enterpriseName = this.queryParam.enterpriseName;
      this.$refs.orderDetailRef.show(value);
    },
    async getList() {
      this.loading = true;
      const { data, extended } = await this.$api.stock.GetStockBatchOrderList({
        ...this.queryParam,
        paging: this.paging,
      });
      this.tableList = data;
      this.total = extended.paging.total;
      this.loading = false;
    },
    async pageFetchData(value) {
      this.type = value.type;
      this.loading = true;
      this.queryParam.orderDirection = value.type;
      this.queryParam.standardCode = value.tableData.standardCode;
      this.queryParam.enterpriseName = value.enterpriseName;
      if (value.type === 0) {
        this.queryParam.nationalDrugCode = value.tableData.nationalDrugCode;
        this.queryParam.batchNo = value.tableData.batchNo;
      } else {
        this.queryParam.nationalDrugCode = "";
        this.queryParam.batchNo = "";
      }
      const { data } = await this.$api.stock.GetStockBatchOrderDetail(
        this.queryParam
      );
      this.drugInfo = data;
      const { data: filterData } =
        await this.$api.stock.GetStockBatchOrderFilter(this.queryParam);
      this.filterData = filterData;
      const { data: tableList, extended } =
        await this.$api.stock.GetStockBatchOrderList({
          ...this.queryParam,
          paging: this.paging,
        });
      this.tableList = tableList;
      this.total = extended.paging.total;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./record.scss";
</style>
